import React, { useContext, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CIcon from '@coreui/icons-react';
import { CButton, CCard, CCardBody, CModal, CModalBody } from '@coreui/react';
import CreateSchedule from './createShedule';
import ScheduleCard from './scheduleCard';
import CenterSpinner from '../../../../../general/Loadings/CenterSpinner';
import { toastError } from '../../../../../../utils';
import { callTokenApi } from '../../../../../../apiCaller';
import { setScheduleSavedReport } from '../../../../../../actions/subscriber';
import { CLIENT_SCHEDULE_SAVED_REPORT } from '../../../../../../constants';
import { ScheduleContext } from '..';

import { useLocation } from 'react-router';
import { useHistory } from "react-router-dom";

const ManageSchedule = ({ savedReports }) => {
     const { showSchedule, setShowSchedule, reportData, setReportData, scheduleReportId } = useContext(ScheduleContext);
     const [showCreate, setShowCreate] = useState({ show: false, id: '' });
     const [isLoading, setIsLoading] = useState(true);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const schedules = useSelector((state) => state.subscriber.scheduleSavedReport) || [];
     const location = useLocation();
     const history = useHistory();
     
     const dispatch = useDispatch();

     useEffect(() => {
          document.body.classList.add('modal-open-schedule');
     }, []) // eslint-disable-line

     useEffect(() => {
          if (scheduleReportId) {
               setShowCreate({show: true, id: scheduleReportId});
               history.push(location.pathname)
          }
     }, [scheduleReportId]) // eslint-disable-line

     useEffect(() => {
          if (showSchedule && activeAccount && reportData) {
               setIsLoading(true);
               callTokenApi(`${CLIENT_SCHEDULE_SAVED_REPORT}/${activeAccount.id}/${reportData.id}`, 'GET')
                    .then((response) => {
                         if (response.status === 200) {
                              dispatch(setScheduleSavedReport(response.data.schedules));
                         } else {
                              toastError(response);
                         }
                    })
                    .catch((error) => {
                         toastError(error);
                    })
                    .finally(() => setIsLoading(false));
          }
     }, [showSchedule, activeAccount, reportData, dispatch]);

     const handleClose = () => {
          document.body.classList.remove('modal-open-schedule');
          setShowSchedule(false);
          setReportData(null);
     };

     const handleCreateSchedule = () => {
          setShowCreate({ show: true });
     };

     return (
          <>
               <div className='form-categories schedule-saved-report goals manager-schedule'>
                    <CModal className='schedule-modal' visible={showSchedule} alignment='center' onClose={handleClose} color='primary' portal={false} backdrop='static'>
                         <CModalBody className='goalsContent'>
                              <CCard className='card form-categories--card form-categories--categorizing'>
                                   <CIcon icon='cil-x' onClick={handleClose} className='icon-close-popup' />
                                   <CCardBody>
                                        <div className='title'>
                                             <h3>Manage Scheduled Deliveries</h3>
                                             <p>Create and manage scheduled email deliveries of the <strong>{reportData?.name}</strong> report.</p>
                                        </div>
                                        <div className='form-actions text-center'>
                                             <div className={`list-rules  ${!isLoading ? 'list-rules-data' : ''}`}>
                                                  {isLoading ? (
                                                       <CenterSpinner />
                                                  ) : schedules.length > 0 ? (
                                                       schedules.map((schedule, index) => (
                                                            <ScheduleCard
                                                                 key={schedule.id || index}
                                                                 savedReports={savedReports}
                                                                 scheduleIndex={index}
                                                                 schedule={schedule}
                                                                 setShowCreate={setShowCreate}
                                                            />
                                                       ))
                                                  ) : (
                                                       <p>No scheduled deliveries exist for this report.</p>
                                                  )}
                                             </div>
                                             <CButton type='button' color='primary' className='mr-3 mt-4' onClick={handleCreateSchedule}>
                                                  Create New Scheduled Delivery
                                             </CButton>
                                        </div>
                                   </CCardBody>
                              </CCard>
                         </CModalBody>
                    </CModal>
                    {!isLoading && (
                         <CreateSchedule savedReports={savedReports} showCreate={showCreate} setShowCreate={setShowCreate} />
                    )}
               </div>
          </>
     );
};

export default ManageSchedule;
